import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { KwikUIAnimationPlayerModule } from "./animation-player/animation-player.module";

@NgModule({
  declarations: [],
  imports: [CommonModule, KwikUIAnimationPlayerModule],
  exports: [KwikUIAnimationPlayerModule]
})
export class KwikUIMiscModule {}
